import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { withTranslation } from 'react-i18next';
import { compose, mapProps } from 'recompose';
import _ from 'lodash';
import PropTypes from 'prop-types';

import ParticipantPopover from 'components/threepp/assessment/Question/ParticipantPopover/ParticipantPopover';
import Header from 'components/common/Header/Header';
import { showErrorMessage } from 'components/common/Alert/Alert';
import { updateAssigneesForCategory } from 'graphql/operations';
import { isAssessmentReadOnly as isAssessmentReadOnlySelector } from 'selectors/assessment/selector';
import { getObjValue } from 'utils/functions';
import { ArrowDropDown } from '@material-ui/icons';

import './CategoryHeader.scss';
import { decodeHtml } from 'utils/htmlEncoderDecoder';

export class CategoryHeader extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    isAssessmentReadOnly: PropTypes.bool,
    // TODO: Fix this...
    /* eslint-disable react/forbid-prop-types */
    category: PropTypes.object.isRequired,
    fullyAssignedUsers: PropTypes.array,
    partiallyAssignedUsers: PropTypes.array,
    assessment: PropTypes.object.isRequired,
    /* eslint-enable react/forbid-prop-types */
    expanded: PropTypes.bool,
    onExpandCollapse: PropTypes.func.isRequired,
    onBulkAssignChange: PropTypes.func.isRequired,
    updateAssigneesForCategory: PropTypes.func.isRequired
  };

  static defaultProps = {
    expanded: false,
    isAssessmentReadOnly: false,
    partiallyAssignedUsers: [],
    fullyAssignedUsers: []
  };

  constructor(props) {
    super(props);
    this.updateAssigneesForCategory = _.debounce(this.updateAssigneesForCategory, 2500);
  }

  updateAssigneesForCategory = (addedParticipants, removedParticipants) => {
    const { updateAssigneesForCategory: propsUpdateAssigneesForCategory, assessment, category, onBulkAssignChange, t } = this.props;
    if (addedParticipants.length > 0 || removedParticipants.length > 0) {
      propsUpdateAssigneesForCategory({
        variables: {
          assessmentId: assessment.id,
          categoryId: category.id,
          emailsToAdd: addedParticipants,
          emailsToRemove: removedParticipants
        }
      })
        .then(() => {
          onBulkAssignChange(category.id, addedParticipants, removedParticipants);
        })
        .catch(error => {
          console.error(error);
          showErrorMessage(t('assessment.categories.assignmentErrorMsg'));
        });
    }
  };

  handleToggleHeader = () => {
    const { expanded, onExpandCollapse } = this.props;
    onExpandCollapse(!expanded);
  };

  handleToggleHeaderOnKeyboard = evt => {
    const { expanded, onExpandCollapse } = this.props;
    evt.key === 'Enter' && onExpandCollapse(!expanded);
  };

  render() {
    const { category, assessment, fullyAssignedUsers, partiallyAssignedUsers, isAssessmentReadOnly, expanded, t } = this.props;

    const title = (
      <>
        <ArrowDropDown
          className={`collapse-icon ${expanded ? 'expanded' : 'collapsed'}`}
          tabIndex={0}
          onClick={this.handleToggleHeader}
          onKeyDown={this.handleToggleHeaderOnKeyboard}
        />
        <h5 className="header-title">{decodeHtml(category.name)}</h5>
      </>
    );

    const content = (
      <span>
        <ParticipantPopover
          disabled={isAssessmentReadOnly}
          header={t('assessment.categories.assignmentTitle')}
          initialAssignees={fullyAssignedUsers}
          initialPartialAssignees={partiallyAssignedUsers}
          assessmentParticipants={assessment.participants}
          onAssigneesChanged={this.updateAssigneesForCategory}
          hideIfNoParticipants={false}
        />
      </span>
    );

    return (
      <div className="category-header">
        <Header title={title} content={content} />
      </div>
    );
  }
}

export const CategoryHeaderHOC = compose(
  withTranslation(),
  graphql(updateAssigneesForCategory, { name: 'updateAssigneesForCategory' }),
  mapProps(props => ({
    t: props.t,
    expanded: props.expanded,
    onExpandCollapse: props.onExpandCollapse,
    assessment: props.assessment,
    onBulkAssignChange: props.onBulkAssignChange,
    updateAssigneesForCategory: props.updateAssigneesForCategory,
    category: props.category,
    fullyAssignedUsers: getObjValue(props, 'category.metadata.fullyAssignedUsers', []),
    partiallyAssignedUsers: getObjValue(props, 'category.metadata.partiallyAssignedUsers', []),
    isAssessmentReadOnly: isAssessmentReadOnlySelector(props)
  }))
);
export default CategoryHeaderHOC(CategoryHeader);
